import { encrypt } from '../../helpers/crypto';
import { minBy, maxBy } from 'lodash';
import config from '../../config/config';

export const territoriesFormatter = {
    formatRollingMonthsRevenue,
    formatTerritories,
    formatSharedUser
};

function formatRollingMonthsRevenue(data) {
    const numberOfGroups = 5; // adjust with the gradient colors
    let timeseries = {
        phy: [],
        dig: [], 
        nr: []
    };
    let pie = {
        phy: 0,
        dig: 0, 
        nr: 0        
    };
    let labels = [];
    data = data.map(item=>{
        let total = 0;
        labels.push(item.month_label);
        for(let key of ['phy', 'dig', 'nr']) {
            const value = item[`${key}_income_r12`];
            total += value;
            timeseries[key].push(value);
            pie[key]+=value;
        }
        item.total_income_r12 = total;
        return item;
    });
    const minRevenue = minBy(data, 'total_income_r12').total_income_r12;
    const maxRevenue = maxBy(data, 'total_income_r12').total_income_r12;
    data = data.map(item=>{
        let normalizedValue = 0;
        if (maxRevenue !== minRevenue) {
            normalizedValue = (item.total_income_r12 - minRevenue) / (maxRevenue - minRevenue);
        }
        item.colorIndex = Math.min(Math.floor(normalizedValue * numberOfGroups), numberOfGroups - 1);
        return item;
    });
    
    
    
    return { data, pie: {
        labels: ['Physical', 'Digital', 'Neighboring Rights'],
        datasets: [
            {data: Object.values(pie), label: 'revenue'}
        ]
    }, timeseries: {labels, datasets: [
        {label: 'Physical', data: timeseries.phy, fill: false},
        {label: 'Digital', data: timeseries.dig, fill: false},
        {label: 'Neighboring Rights', data: timeseries.nr, fill: false},
    ]} };
}

function formatCountries(countries) {
    let sortedEntries = Object.entries(countries);
    
    sortedEntries.sort((a, b) => {
      const [continentA, seriesA] = a;
      const [continentB, seriesB] = b;
    
      // 'Other' always goes to the end
      if (continentA === 'Other') return 1;
      if (continentB === 'Other') return -1;
    
      // Calculate sums for comparison
      const sumA = seriesA.reduce((acc, val) => acc + val, 0);
      const sumB = seriesB.reduce((acc, val) => acc + val, 0);
    
      // Sort in descending order of sum
      return sumB - sumA;
    });
    
    return Object.fromEntries(sortedEntries);
}

function formatTerritories(data) {
    let years = [];
    let results = {}, countries = {};
    for(let row of data) {
        const sourceTotal = row.digital + row.physical;
        row.digital_ratio = Math.round(row.digital / sourceTotal * 100) ;
        row.physical_ratio = Math.round(row.physical / sourceTotal * 100 ) ;
        for(let key of Object.keys(row)) {
            if(key == 'incomes') {
                for(let entry of row.incomes) {
                    const country = entry.continent || entry.country_code;
                    if(!countries[country])
                        countries[country] = [];
                    countries[country].push(entry.income)
                }
            } else {
                if(!results.hasOwnProperty(key))
                    results[key] = [];
                results[key].push(row[key])
            }
        }
    }
    countries = formatCountries(countries);
    return {results, countries, table: data};
}

function formatSharedUser(user){
    user.sharedToken = true;
    // token is encrypted for share domain
    return encrypt(JSON.stringify(user), config.apis.shared);
}